/**
 * Specifies the type of limit check message.
 * tag: 2321
 * @readonly
 * @enum {number} (int)
 */
export enum RiskLimitCheckType {
  Submit = 0,
  LimitConsumed = 1,
}
